// src/store/store.js

import { applyMiddleware, createStore } from "redux";
import { createLogger } from "redux-logger";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunkMiddleware from "redux-thunk";

import { getIsCypressAut } from "../helpers/isCypressAut";
import authRefreshMiddleware from "../middlewares/authRefresh.midware";
import pbhRepairMiddleware from "../middlewares/pbhrepair.midware";
import salesOrderMiddleware from "../middlewares/salesorder.midware";
import rootReducer from "../reducers";
import { pbhApi } from "../services/pbhApi";

const loggerMiddleware = createLogger({
  predicate: (_getState, action) =>
    Boolean(action && typeof action.type !== "undefined"),
});
const persistConfig = {
  key: "root",
  storage,
  blacklist: [pbhApi.reducerPath],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const salesOrderMidware = salesOrderMiddleware();
const authRefreshMidware = authRefreshMiddleware();
const pbhRepairMidware = pbhRepairMiddleware();

export const store = createStore(
  // rootReducer,
  persistedReducer,
  applyMiddleware(
    thunkMiddleware,
    authRefreshMidware,
    salesOrderMidware,
    pbhRepairMidware,
    pbhApi.middleware,
    loggerMiddleware,
  ),
);

//check if we're in a cypress environment and assigns redux store to window object if so
if (getIsCypressAut()) {
  window.store = store;
}
